import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSetNewPasswordSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 215,
	height: 89,
	viewBox: "0 0 215 89",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.92765 7.54526C6.57469 6.35852 8.27867 6.35853 8.92571 7.54526L9.53268 8.6585C9.68971 8.94651 9.92638 9.18318 10.2144 9.34021L11.3276 9.94718C12.5144 10.5942 12.5144 12.2982 11.3276 12.9452L10.2144 13.5522C9.92638 13.7092 9.68971 13.9459 9.53268 14.2339L8.92571 15.3472C8.27867 16.5339 6.57469 16.5339 5.92765 15.3472L5.32068 14.2339C5.16365 13.9459 4.92698 13.7092 4.63897 13.5522L3.52573 12.9452C2.33899 12.2982 2.33899 10.5942 3.52573 9.94718L4.63897 9.34021C4.92698 9.18318 5.16365 8.94651 5.32068 8.6585L5.92765 7.54526Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.074 77.9818C206.721 76.795 208.425 76.795 209.072 77.9818L209.679 79.095C209.836 79.383 210.073 79.6197 210.361 79.7767L211.474 80.3837C212.661 81.0307 212.661 82.7347 211.474 83.3818L210.361 83.9887C210.073 84.1458 209.836 84.3824 209.679 84.6704L209.072 85.7837C208.425 86.9704 206.721 86.9704 206.074 85.7837L205.467 84.6704C205.31 84.3824 205.073 84.1458 204.785 83.9887L203.672 83.3818C202.485 82.7347 202.485 81.0307 203.672 80.3837L204.785 79.7767C205.073 79.6197 205.31 79.383 205.467 79.095L206.074 77.9818Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 22.6928,
			cy: 2.62363,
			rx: 2.87447,
			ry: 2.15585,
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.4284 53.0889L49.9626 48.0825L39.5553 51.4201L39.6286 40.2695H34.4982L34.5715 51.4201L24.0909 48.0825L22.5518 53.0889L32.9591 56.3506L26.3629 65.3772L30.3939 68.4873L36.9901 59.3089L43.6595 68.4873L47.7638 65.3772L41.0944 56.3506L51.4284 53.0889Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.1562,
			y: 27.873,
			width: 53.6686,
			height: 53.0097,
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.653 53.0889L116.187 48.0825L105.78 51.4201L105.853 40.2695H100.723L100.796 51.4201L90.3155 48.0825L88.7764 53.0889L99.1837 56.3506L92.5875 65.3772L96.6185 68.4873L103.215 59.3089L109.884 68.4873L113.988 65.3772L107.319 56.3506L117.653 53.0889Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 76.3809,
			y: 27.873,
			width: 53.6686,
			height: 53.0097,
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.879 53.0889L182.413 48.0825L172.005 51.4201L172.079 40.2695H166.948L167.022 51.4201L156.541 48.0825L155.002 53.0889L165.409 56.3506L158.813 65.3772L162.844 68.4873L169.44 59.3089L176.11 68.4873L180.214 65.3772L173.545 56.3506L183.879 53.0889Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 142.606,
			y: 27.873,
			width: 53.6686,
			height: 53.0097,
			stroke: "#3C59F6",
			strokeWidth: 2
		})
	]
});
export default SvgSetNewPasswordSuccess;
